import { Label, Switch } from '@planuze/ui';
import { usePlansContent } from '../../../content/sections/plans.js';
import type { PlanForm } from '../../../hooks/use-plan-form.js';

/* Fontes de herança do marketplace (ADR-0595). Reusado na criação e na edição negociada
   para manter exatamente a mesma semântica de seleção. */
export function InheritanceFields({ form }: { readonly form: PlanForm }) {
  const copy = usePlansContent();
  return (
    <div className="space-y-2 rounded-md border border-border p-3">
      <Label className="text-sm font-medium">{copy.formFields.inheritTitle}</Label>
      <p className="text-sm text-muted-foreground">{copy.formFields.inheritDescription}</p>
      {form.sourcePlans.length === 0 ? (
        <p className="text-sm text-muted-foreground">{copy.formFields.noSourcePlans}</p>
      ) : (
        <div className="space-y-1.5">
          {form.sourcePlans.map((plan) => (
            <div key={plan.id} className="flex items-center justify-between gap-3">
              <span className="text-sm text-foreground">
                {plan.displayName} <span className="text-muted-foreground">({plan.tier})</span>
              </span>
              <Switch
                aria-label={copy.formFields.inheritAriaLabel(plan.displayName)}
                checked={form.inheritedPlanKeys.includes(plan.tier)}
                onCheckedChange={(enabled) =>
                  form.setInheritedPlanKeys((previous) =>
                    enabled
                      ? Array.from(new Set([...previous, plan.tier]))
                      : previous.filter((key) => key !== plan.tier),
                  )
                }
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
